
<template>

	<modal :name="name" ref="modal" :resizable="resizable" adaptive :draggable="drag_only_head ? '.window-header' : '.all_window'" reset v-on:opened="opened" v-on:before-open="my_reset" styles="visibility: hidden;" :shiftY="shift_y" :minHeight="min_height" :width="width" :minWidth="min_width" v-on:resize="resize_modal" :maxHeight="max_height" :clickToClose="false">

		<div ref="all_window" @dragover.prevent v-on:dragover="drag_start" v-on:drop.stop.prevent="drop" class="all_window main-container" v-resize:throttle="resize_window">

			<div ref="content" class="main-container main-container_content">
				
				<div ref="title" class="pt-4 mx-4 window-header">

					<h3>{{ title }}</h3>
					<button class="close" v-on:click="() => my_cancel()"></button>

				</div>

				<div ref="main" class="mx-4 main-container main-container_content" v-resize:throttle="resize_main">
					
					<slot/>

				</div>

			</div>

			<div ref="footer" align="right" class="window-footer pb-4 mx-4">

				<b-button v-if="! without_cancel" variant="outline-primary-secondary" v-on:click="() => my_cancel()">{{ cancel }}</b-button>
				<b-button v-if="! without_ok" class="mx-1" variant="primary" :disabled="! my_check() || ok_disabled" v-on:click="() => my_ok()">{{ ok }}</b-button>

				<slot name="buttons"/>

			</div>

		</div>

	</modal>

</template>

<script>

import { uuid } from "vue-uuid"
import resize from "vue-resize-directive"

export default
{
	props :
	{
		title : String,
		ok : String,
		reset : Function,
		submit : Function,
		resizable : { type : Boolean, default : () => true },
		check : { type : Function, default : () => () => true },
		cancel : { type : String, default : () => "Отменить" },
		cancel_func : { type : Function, default : null },
		without_cancel : { type : Boolean, default : () => false },
		without_ok : { type : Boolean, default : () => false },
		ok_disabled : { type : Boolean, default : () => false },
		ok_hide : { type : Boolean, default : () => true },
		width : { type : String, default : () => "600px" },
		height : { type : Number, default : () => null },
		vheight : { type : Number, default : () => null },
		min_width : { type : Number, default : () => 300 },
		drag_only_head : { type : Boolean, default : () => false },
	},

	directives :
	{
		resize,
	},

	data()
	{
		return {

			name : uuid.v1(),
			shift_y : 0.5,
			min_height : 0,
			filler_height : 0,
			max_height: 0,
			custom_height : null

		}
	},

	mounted()
	{
		this.max_height = window.innerHeight * 0.95
	},

	methods :
	{
		opened()
		{
			var height = this.get_height() || this.$refs.content.clientHeight + 90
			const window_height = window.innerHeight

			if(window_height > height)
				this.shift_y = ( window_height - height ) / ( 2 * window_height )
			else
			{
				this.shift_y = 0
				height = window_height
			}

			this.set_height(height)
			this.$refs.modal.$el.querySelector(".vm--modal").style.visibility = null
			
			this.$slots.default.forEach((node) => {
				if (node.tag)
				{
					new ResizeObserver(this.resize_main).observe(node.elm)
				}
			})
			this.min_height = height

			this.$emit("shown")
		},

		resize_main()
		{
			if (this.$refs.all_window)
			{
				this.$refs.modal.$el.querySelector && (this.$refs.modal.$el.querySelector(".vm--modal").style.height = this.custom_height || this.get_height())
				this.resize_window()
			}
		},

		resize_window()
		{
			this.set_height(this.$refs.all_window.clientHeight)
		},

		resize_modal()
		{
			var find_select = 
				elem =>
				{
					if(elem.$options._componentTag == "v-select")
						elem.closeSearchOptions()
					else
						elem.$children.forEach(find_select)
				}

			find_select(this.$refs.modal)
			if (this.min_height == this.$refs.all_window.clientHeight)
			{
				this.custom_height = null
			}
			else
			{
				this.custom_height = this.$refs.all_window.clientHeight
			}
		},

		set_height(height)
		{
			if (height < this.min_height)
			{
				this.min_height = height
			}

			height = (height > this.max_height || !height) ? this.max_height : height
			this.$refs.modal.$el.querySelector(".vm--modal").style.height = height.toString() + "px"
			this.shift_y = ( window.innerHeight - height ) / ( 2 * window.innerHeight )
		},

		get_height()
		{
			if (this.height)
			{
				return this.height
			}
			else if (this.vheight)
			{
				return window.innerHeight * this.vheight
			}
			else
			{
				return null
			}
		},

		my_check()
		{
			return this.$props.check()
		},

		my_reset()
		{
			this.$props.reset()
			this.custom_height = null
		},

		execute()
		{
			this.$modal.show(this.name)
		},

		my_ok()
		{
			if(! this.my_check())
				return

			var promise = this.$props.submit()

			if(this.ok_hide)
			{
				if(promise == null)
					this.my_hide()
				else
					promise.then(
						result =>
						{
							if(result)
								this.my_hide()
						})
			}
		},

		my_cancel()
		{
			if (this.cancel_func)
			{
				this.cancel_func()
			}
			else
			{
				this.$modal.hide(this.name)
			}
		},

		my_hide()
		{
			this.$modal.hide(this.name)
		},

		drag_start(event)
		{
			event.dataTransfer.effectAllowed = "all"
			event.dataTransfer.dropEffect = "move"
		},

		drop(event)
		{
			this.$emit("drop", event)
		},
	}
}

</script>

<style>

.vm--modal
{
	overflow: unset !important;
}

#vue-modal-triangle
{
	z-index: 100 !important;
}

.window-header
{
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: .5rem;
	user-select: none;
	margin-bottom: 11px;
}

.window-header .close
{
	min-width: .875rem;
	height: .875rem;
}

.window-footer
{
	margin-top: 11px;	
}

.window-footer .btn-primary:disabled
{
	background-color: var(--bft-neutral-300);
	border-color: var(--bft-neutral-300);
	opacity: unset;
}

.all_window
{
	height: 100%;
}

</style>

